var _path, _path2, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddToBasket(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 43,
    height: 21,
    viewBox: "0 0 43 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11H17.5",
    stroke: "white",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5V17",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2_10130)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.375 19.25C29.8582 19.25 30.25 18.8582 30.25 18.375C30.25 17.8918 29.8582 17.5 29.375 17.5C28.8918 17.5 28.5 17.8918 28.5 18.375C28.5 18.8582 28.8918 19.25 29.375 19.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39 19.25C39.4832 19.25 39.875 18.8582 39.875 18.375C39.875 17.8918 39.4832 17.5 39 17.5C38.5168 17.5 38.125 17.8918 38.125 18.375C38.125 18.8582 38.5168 19.25 39 19.25Z",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.375 0.875H25.875L28.22 12.5913C28.3 12.9941 28.5192 13.356 28.8391 13.6135C29.159 13.8711 29.5594 14.0079 29.97 14H38.475C38.8856 14.0079 39.286 13.8711 39.6059 13.6135C39.9258 13.356 40.145 12.9941 40.225 12.5913L41.625 5.25H26.75",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_10130"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21,
    height: 21,
    fill: "white",
    transform: "translate(21.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddToBasket);
export default __webpack_public_path__ + "static/media/add_to_basket.c3c86cadea20d700595a31e195ece294.svg";
export { ForwardRef as ReactComponent };